<template>
    <div id="patients-portal-summary-container">
        <div class="page-height">
            <MdTitleRegInfo
                v-bind:RegistrationInfo="PatientTitle"
                v-bind:titlePrefix="$t('PatientPortalDashboard.Title')"
                v-bind:titleRef="'titleElementPatientSummary'"
                v-bind:patientCode="$route.params.id"
            >
            </MdTitleRegInfo>

            <div class="row">
                <MdPatientInfoBox
                    v-bind:PatientCode="$route.params.id"
                    v-bind:ShowPortalStatus="true"
                ></MdPatientInfoBox>
            </div>

            <div class="row">
                <MdPatientContactsBox
                    v-bind:PatientCode="$route.params.id"
                    :goToPatientContactsButtonVisible="goToPatientContactsButtonVisible"
                ></MdPatientContactsBox>
            </div>

            <div class="space-actions"></div>
            <div class="page-actions"></div>
        </div>

        <MDTextEditorDialog
            :visible="textEditorVisible"
            :value="textEditorValue"
            @close="closeTextEditorHandler"
            @ok="closeTextEditorHandler"
            :handlerOk="closeTextEditorHandler"
            :required="false"
            :buttonSaveHidden="true"
            :isReadOnly="true"
            :title="$t('PatientPortalDashboard.Title')"
        />

        <patient-portal-change-password
            :visible.sync="changePasswordVisible"
            :userName="selectedUserName"
        />

        <patient-portal-create-login
            :visible.sync="createLoginVisible"
            :patientCode="patientCodeFirstOrDefault"
            :fullName="selectedFullName"
            :email="selectedEmail"
            @ok="createLoginHandler"
        />

        <patient-portal-change-user-name
            :visible.sync="changeUserNameVisible"
            :patientCode="patientCodeFirstOrDefault"
            :fullName="selectedFullName"
            :userName="selectedUserName"
            @ok="createLoginHandler"
        />

        <patient-portal-notify
            :visible.sync="notifyVisible"
            :patientCodeList="selectedPatientCodeList"
            :notifyType="notifyType"
            :notifyTemplateList="
                notifyType === 'email' ? notifyEmailTemplateList : notifyTextTemplateList
            "
        />
    </div>
</template>

<script>
import PatientsPortalBase from './patientsPortalBase.vue';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import PatientPortalsService from '@/services/patientportals.service';
import { patientsPortalStore } from './patientsPortalStore';
import PatientPortalChangePassword from './dialogs/patientPortalChangePassword.vue';
import PatientPortalCreateLogin from './dialogs/patientPortalCreateLogin.vue';
import PatientPortalChangeUserName from './dialogs/patientPortalChangeUserName.vue';
import PatientPortalNotify from './dialogs/patientPortalNotify.vue';

export default {
    name: 'PatientsPortalSummary',
    extends: PatientsPortalBase,
    components: {
        PatientPortalChangePassword,
        PatientPortalCreateLogin,
        PatientPortalChangeUserName,
        PatientPortalNotify
    },
    data() {
        return {
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalSummaryItems))
        };
    },
    computed: {
        goToPatientContactsButtonVisible() {
            return this.$store.state.isPatientPortalContacts;
        }
    },
    methods: {
        getActiveElement() {
            return 'PPDB_Summary';
        },

        createLoginHandler(item) {
            this.selectedItems = [item];
            this.enabledAllItems();
        },

        async loadPatientTitle(patientCode) {
            const infoList = await this.getInfoTitle(patientCode);
            if (infoList && infoList.length > 0) {
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];
                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = `${firstname} ${lastname}`;
            }
        },

        async loadPortalPatient(patientCode) {
            const response = await PatientPortalsService.getAllDashboard({
                PageSize: 1,
                PageNumber: 1,
                PatientCodeList: [patientCode],
                status: null,
                portalStatus: null
            });
            if (response.status === 200 && response.data && response.data.length > 0) {
                this.selectedItems = response.data.filter(
                    x => x.patientCode.trim() === patientCode.trim()
                );
            }
        },

        enabledAllItems() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            this.RightMenuList.forEach(element => {
                let buttonEnabled = false;
                switch (element.value) {
                    case 'PPDB_CreateCredentials':
                        buttonEnabled =
                            item &&
                            item.portalStatus === 'Not Enrolled' &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email) &&
                            !!item.dob;
                        break;
                    case 'PPDB_CreateAuthLogins':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    case 'PPDB_CreateLogin':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    case 'PPDB_ChangeUsername':
                    case 'PPDB_ChangePassword':
                        buttonEnabled = item && !Utils.isNullOrEmptyString(item.userName);
                        break;
                    case 'PPDB_PatientForms':
                    case 'PPDB_PatientContacts':
                    case 'PPDB_PatientClaims':
                    case 'PPDB_PatientInfo':
                    case 'PPDB_Summary':
                    case 'PPDB_ChangePatInfo':
                    case 'PPDB_Messages':
                    case 'PPDB_PatientList':
                        buttonEnabled = true;
                        break;
                    case 'PPDB_EmailToPatient':
                        buttonEnabled = this.isNotify('email');
                        break;
                    case 'PPDB_TextToPatient':
                        buttonEnabled = this.isNotify('text');
                        break;
                    default:
                        break;
                }
                element.ReadOnly = !buttonEnabled;
            });

            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
            this.OptionsRightMenu.ItemsList = this.RightMenuList;
            this.OptionsRightMenu.active_el = this.getActiveElement();
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        }
    },

    async mounted() {
        const patientCode = this.$route.params.id;
        if (patientCode) {
            await this.$nextTick();
            EventBus.$emit('loadMenu', patientCode);
            const stored = patientsPortalStore.selectedItem;
            if (stored && stored.patientCode.trim() === patientCode.trim()) {
                this.selectedItems = [stored];
                patientsPortalStore.selectedItem = null;
                await this.loadPatientTitle(patientCode);
            } else {
                await Promise.all([
                    this.loadPatientTitle(patientCode),
                    this.loadPortalPatient(patientCode)
                ]);
            }
        }
        this.enabledAllItems();
    }
};
</script>
